<template>
  <div class="service-request-page-step__wrapper step-4">
    <div class="service-request-page-step__fields service-request-page-step__fields-step-4">
      <BaseInput
        v-model="form.last_name"
        :label="getMain.form.last_name.label"
        :required="getMain.form.last_name.required"
        :errorMsg="errorMsgs.last_name"
        class="service-request-page__form-input"
        name="last_name"
      />
      <BaseInput
        v-model="form.first_name"
        :label="getMain.form.first_name.label"
        :required="getMain.form.first_name.required"
        :errorMsg="errorMsgs.first_name"
        class="service-request-page__form-input"
        name="first_name"
      />
      <BaseInputTel
        v-model="form.phone"
        :label="getMain.form.phone.label"
        :required="getMain.form.phone.required"
        :errorMsg="errorMsgs.phone"
        type="tel"
        class="service-request-page__form-input"
        name="phone"
      />
      <BaseSelectNew
        v-model="form.contact_method"
        :items="getMain.form.contact_method.items"
        :placeholder="getMain.form.contact_method.placeholder || ' '"
        :label="getMain.form.contact_method.label"
        :required="getMain.form.contact_method.required"
        :errorMsg="errorMsgs.contact_method"
        class="service-request-page__form-input-date"
      />
    </div>
    <BaseButton
      class="service-request-page__button"
      type="primary"
      :disabled="!form.contact_method || !form.phone || !form.last_name || !form.first_name"
      @click="submitForm"
    >
      {{ getMain.continueButtonText }}
    </BaseButton>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import IconArrow from '@/assets/img/icons/arrow-long-right.svg?inline'
  import { isMd } from '@/config'

  export default {
    name: 'Step4',
    components: {
      IconArrow
    },
    props: {
      form: [Object, String],
      submitForm: Function,
      errorMsgs: Object
    },

    computed: {
      isMd () {
        return isMd
      },

      ...mapGetters(['getMain', 'isShow', 'getPhoneType']),
      ...mapState(['currentLang'])
    },

    methods: {
      ...mapActions(['submitServiceRequest'])
    }
  }
</script>

<style lang="scss">
.service-request-page-step__fields-step-4 {
  grid-template-columns: repeat(4, 1fr);
  margin-bottom: 0;

  @include tablet {
    grid-template-columns: 1fr 1fr;
  }

  @include mobile {
    grid-template-columns: 1fr;
  }

  .input-wrapper {
    width: 100% !important;
    min-width: 100%;

    @include tablet {
      padding-bottom: 0 !important;
    }
  }
}

.step-4 {
  .service-request-page__button {
    margin-top: 5px;

    @include tablet {
      margin-top: 15px;
    }

    @include mobile {
      margin-top: 23px;
    }
  }
}

</style>
